// src/components/PageHeaderStack.jsx
//
// OBJECT-HEADER-ALIGN-S1 — shared page-header layout primitive.
//
// Single source of truth for the outer container constraints (maxWidth,
// horizontal padding, margin auto) AND the flex-column gap between the
// three canonical header rows (KPI strip → toolbar → StatusBand).
//
// Usage:
//   <PageHeaderStack>
//     <KpiTileRow ...>…</KpiTileRow>
//     <div data-testid="…-toolbar">…</div>
//     <StatusBand .../>          {/* conditional — only when alertsActionable */}
//     {/* remaining page content can follow as additional children */}
//   </PageHeaderStack>
//
// Each page's outer wrapper div should carry NO maxWidth / padding / margin
// of its own — this component is the single place those constraints live.
// The outer wrapper only holds semantic attributes (data-testid, minHeight,
// etc.) that are not part of the layout contract.

import React from "react";

export const PAGE_CONTENT_MAX_WIDTH = "1400px";
export const PAGE_CONTENT_PADDING   = "0 32px";

export function PageHeaderStack({ children, className }) {
  return (
    <div
      className={className}
      style={{
        maxWidth:      PAGE_CONTENT_MAX_WIDTH,
        padding:       PAGE_CONTENT_PADDING,
        margin:        "0 auto",
        width:         "100%",
        display:       "flex",
        flexDirection: "column",
        gap:           12,
      }}
    >
      {children}
    </div>
  );
}
